import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Row, Form } from "react-bootstrap";
import EmptyClaimSubmitModal from "./EmptyClaimSubmitModal.js";
import SubmitMultipleClaimModal from "./SubmitMultipleClaimModal.js";
import SubmitClaimModal from "./SubmitClaimModal.js";
import SuccessSubmitModal from "./SuccessSubmitModal.js";
import CancelMultipleClaimModal from "./CancelMultipleClaimModal.js";
import ErrorMultiplecancelModal from "./ErrorMultiplecancelModal.js";
import ResubmitMultipleclaimModal from "./ResubmitMultipleclaimModal.js";
import ErrorMultipleResubmitModal from "./ErrorMultipleResubmitModal.js";
import { useDispatch, useSelector } from "react-redux";
import { GetAllClaimsList } from "../config/cliamApi.js";
import { setSelectedTableRow } from "../config/claimSlice.js";

const TableComponentHeader = ({
  table,
  body,
  setFormError,
  setPage,
  setRowsPerPage,
  totalBody,
}) => {
  const dispatch = useDispatch();
  const { claimFilters } = useSelector((state) => state.claim);
  const { allPermissionType } = useSelector((state) => state.role);
  const claimsSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) =>
      item?.rolemngmttyp_name === "Claim" ||
      item?.rolemngmttyp_name === "Claims",
  );
  const [claimLength, setClaimLength] = useState(0);
  const [claims, setClaims] = useState(0);
  const [show, setShow] = useState(false);
  const [status, setStatus] = useState(null);
  const [title, setTitle] = useState(null);
  const [description, setDescription] = useState(null);
  const [cancelCaims, setCancelClaims] = useState(null);
  const [resubmitCalim, setResubmitClaims] = useState(false);
  const [submitCalim, setSubmitClaims] = useState(false);
  const [errorSubmitCalim, setErrorSubmitClaims] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorDescription, setErrorDescription] = useState(null);
  const [showFailedModal, setShowFailedModal] = useState(null);
  const [showCancelFailedModal, setShowCancelFailedModal] = useState(null);
  const [cancelData, setCancelData] = useState(null);
  const [resubmitData, setResubmitData] = useState(null);
  const [showResubmitFailedModal, setShowResubmitFailedModal] = useState(null);

  const selectedRowCount = table?.getSelectedRowModel()?.rows?.length ?? 0;
  const selectedClaims = table
    ?.getSelectedRowModel()
    ?.rows?.map((item) => item?.original);

  // State to track the selected action
  const [selectedAction, setSelectedAction] = useState("Select Actions");
  console.log({ selectedAction });
  // Handle action selection
  const handleActionChange = (e) => {
    setSelectedAction(e.target.value);
  };

  // Handle Apply button clickn
  const handleApplyClick = () => {
    if (
      claimFilters?.start_date &&
      claimFilters?.end_date &&
      selectedAction !== "Select Actions"
    ) {
      const start = new Date(claimFilters.start_date);
      const end = new Date(claimFilters.end_date);

      const sameMonth =
        start.getFullYear() === end.getFullYear() &&
        start.getMonth() === end.getMonth();

      if (!sameMonth) {
        setFormError("start_date", {
          type: "manual",
          message: "Start Date and End Date must be in the same month",
        });
        return;
      }
    }
    if (selectedAction === "delete") {
      const filteredClaims = selectedClaims?.filter(
        (claim) =>
          claim?.claim_status?.toLowerCase() === "withdrawn" ||
          claim?.clm_status?.toLowerCase() === "withdrawn" ||
          claim?.claim_status?.toLowerCase() == "ready to submit" ||
          claim?.clm_status?.toLowerCase() == "ready to submit" ||
          claim?.clm_status?.toLowerCase() == "validation error" ||
          claim?.clm_status?.toLowerCase() == "validation error",
      );
      setClaims(filteredClaims);
      setClaimLength(filteredClaims?.length);
      setStatus("delete");
      setShow(true);
      setTitle("Deletion Not Allowed");
      setDescription(
        "Only Claim Statuses (Ready to submit , withdrawn) can be deleted",
      );
    } else if (selectedAction === "withdraw") {
      const filteredClaims = selectedClaims.filter(
        (claim) =>
          claim?.claim_status?.toLowerCase() == "ready to submit" ||
          claim?.clm_status?.toLowerCase() == "ready to submit",
      );
      setClaimLength(filteredClaims?.length);
      setClaims(filteredClaims);
      setStatus("withdrawn");
      setShow(true);
      setTitle("Cannot Withdraw Records");
      setDescription("Only Claim Status (Ready to submit) can be withdrawn");
    } else if (selectedAction === "unwithdraw") {
      const filteredClaims = selectedClaims.filter(
        (claim) =>
          claim?.claim_status?.toLowerCase() === "withdrawn" ||
          claim?.clm_status?.toLowerCase() === "withdrawn",
      );
      setClaimLength(filteredClaims?.length);
      setClaims(filteredClaims);
      setStatus("unwithdrawn");
      setShow(true);
      setTitle("Unwithdrawal Not Allowed");
      setDescription("Only Claim Status (withdrawn) can be Unwithdrawn");
    } else if (selectedAction === "cancel") {
      const filteredClaims = selectedClaims.filter(
        (claim) =>
          claim?.claim_status?.toLowerCase() === "approved" ||
          claim?.clm_status?.toLowerCase() === "approved" ||
          claim?.claim_status?.toLowerCase() === "partial" ||
          claim?.clm_status?.toLowerCase() === "partial" ||
          claim?.claim_status?.toLowerCase() === "partial approved" ||
          claim?.clm_status?.toLowerCase() === "partial approved" ||
          claim?.claim_status?.toLowerCase() === "queued" ||
          claim?.clm_status?.toLowerCase() === "queued" ||
          claim?.claim_status?.toLowerCase() === "pended" ||
          claim?.clm_status?.toLowerCase() === "pended" ||
          claim?.claim_status?.toLowerCase() === "rejected" ||
          claim?.clm_status?.toLowerCase() === "rejected",
      );
      const claimTypes = [...new Set(filteredClaims.map((r) => r.claim_type))];

      if (claimTypes?.length > 1) {
        setClaimLength(0);
        setClaims([]);
        setStatus("cancel");
        setCancelClaims(true);
        setTitle("Cancellation Not Allowed");
        setDescription(
          "Claims Cancellation batch should have one claim type (Institutional/Professional) for cancelltion.Please select Claims for same type.",
        );
      } else {
        setClaimLength(filteredClaims?.length);
        setClaims(filteredClaims);
        setStatus("cancel");
        setCancelClaims(true);
        setTitle("Cancellation Not Allowed");
        setDescription(
          "Only Claim Status (Approved , Partially Approved , Rejected , Pended and Queued) can be Cancelled",
        );
      }
    } else if (selectedAction === "resubmit") {
      const filteredClaims = selectedClaims.filter(
        (claim) =>
          claim?.claim_status?.toLowerCase() === "invalid" ||
          claim?.clm_status?.toLowerCase() === "invalid" ||
          claim?.claim_status?.toLowerCase() === "cancelled" ||
          claim?.clm_status?.toLowerCase() === "cancelled" ||
          claim?.claim_status?.toLowerCase() === "invalid" ||
          claim?.clm_status?.toLowerCase() === "invalid",
      );
      const claimTypes = [...new Set(filteredClaims.map((r) => r.claim_type))];

      if (claimTypes?.length > 1) {
        setClaimLength(0);
        setClaims([]);
        setStatus("resubmit");
        setResubmitClaims(true);
        setTitle("Resubmission Not Allowed");
        setDescription(
          "Claims Resubmission batch should have one claim type (Institutional/Professional) for resubmission.Please select Claims for same type.",
        );
      } else {
        setClaimLength(filteredClaims?.length);
        setClaims(filteredClaims);
        setStatus("resubmit");
        setResubmitClaims(true);
        setTitle("Resubmission Not Allowed");
        setDescription(
          "Only Claim Status (Error and Cancelled) can be Resubmitted",
        );
      }
    } else if (selectedAction === "submit") {
      const filteredClaims = selectedClaims.filter(
        (claim) =>
          claim?.claim_status?.toLowerCase() == "ready to submit" ||
          claim?.clm_status?.toLowerCase() == "ready to submit",
      );
      const claimTypes = [...new Set(filteredClaims.map((r) => r.claim_type))];

      if (claimTypes?.length > 1) {
        setClaimLength(0);
        setClaims([]);
        setStatus("submit");
        setSubmitClaims(true);
        setTitle("Submission Not Allowed");
        setDescription(
          "Claims Submission batch should have one claim type (Institutional/Professional) for submission.",
        );
      } else {
        setClaimLength(filteredClaims?.length);

        setClaims(filteredClaims);
        setStatus("submit");
        setSubmitClaims(true);
        setTitle("Sunmission Not Allowed");
        setDescription("Only Claim Status (Ready to submit) can be Submitted");
      }
    }

    setSelectedAction("Select Actions");
    table.resetRowSelection();
  };

  const handleSubmitAll = async () => {
    if (claimFilters?.start_date && claimFilters?.end_date) {
      const start = new Date(claimFilters.start_date);
      const end = new Date(claimFilters.end_date);

      const sameMonth =
        start.getFullYear() === end.getFullYear() &&
        start.getMonth() === end.getMonth();

      if (!sameMonth) {
        setFormError("start_date", {
          type: "manual",
          message: "Start Date and End Date must be in the same month",
        });
        return;
      }
    }
    const response = await dispatch(GetAllClaimsList(totalBody)).unwrap();
    const allClaims = response?.data?.claim_data || [];
    const filteredClaims = allClaims.filter(
      (claim) =>
        claim?.claim_status?.toLowerCase() === "ready to submit" ||
        claim?.clm_status?.toLowerCase() === "ready to submit",
    );

    const claimTypes = [...new Set(filteredClaims.map((r) => r.claim_type))];

    if (claimTypes?.length > 1) {
      setClaimLength(0);
      setClaims([]);
      setStatus("submit");
      setSubmitClaims(true);
      setTitle("Submission Not Allowed");
      setDescription(
        "Claims Submission batch should have one claim type (Institutional/Professional) for submission.Please select Claims for same type.",
      );
    } else {
      setClaimLength(filteredClaims?.length);
      setClaims(filteredClaims);
      setStatus("submit");
      setSubmitClaims(true);
      setTitle("Submittion Not Allowed");
      setDescription("Only Claim Status (Ready to Submit) can be Submitted");
    }
  };
  const prevSelectedRef = useRef([]);

  useEffect(() => {
    const currentSelected = selectedClaims || [];
    if (
      JSON.stringify(currentSelected) !==
      JSON.stringify(prevSelectedRef.current)
    ) {
      dispatch(setSelectedTableRow(currentSelected));
      prevSelectedRef.current = currentSelected;
    }
  }, [selectedClaims, dispatch]);

  return (
    <>
      <Row className="flex-between-center py-2">
        <Col xs={12} className="text-end">
          <div className="d-flex justify-content-end align-items-center gap-3">
            {Number(claimsSetting?.submit) === 1 && (
              <Button
                type="button"
                variant="success"
                size="sm"
                className="ms-1"
                onClick={handleSubmitAll}
              >
                Submit All
              </Button>
            )}
            {selectedRowCount > 0 && (
              <>
                <Form.Select
                  size="sm"
                  className="w-auto ms-1"
                  aria-label="Bulk actions"
                  value={selectedAction}
                  onChange={handleActionChange}
                >
                  <option value="Select Actions">Select Actions</option>
                  {Number(claimsSetting?.submit) === 1 && (
                    <option value="submit">Submit</option>
                  )}
                  {Number(claimsSetting?.submit) === 1 && (
                    <option value="resubmit">Resubmit</option>
                  )}
                  {Number(claimsSetting?.cancel) === 1 && (
                    <option value="cancel">Cancel</option>
                  )}
                  {Number(claimsSetting?.cancel) === 1 && (
                    <option value="withdraw">WithDraw</option>
                  )}
                  {Number(claimsSetting?.cancel) === 1 && (
                    <option value="unwithdraw">UnwithDraw</option>
                  )}
                  {Number(claimsSetting?.delete) === 1 && (
                    <option value="delete">Delete</option>
                  )}
                </Form.Select>
                <Button
                  type="button"
                  variant="secondary"
                  size="sm"
                  className="ms-1"
                  onClick={handleApplyClick}
                >
                  Apply
                </Button>
              </>
            )}
          </div>
        </Col>
      </Row>
      {show && claimLength === 0 && (
        <EmptyClaimSubmitModal
          show={show}
          onClose={() => setShow(false)}
          title={title}
          description={description}
        />
      )}

      {cancelCaims && claimLength === 0 && (
        <EmptyClaimSubmitModal
          show={cancelCaims}
          onClose={() => setCancelClaims(false)}
          title={title}
          description={description}
        />
      )}

      {resubmitCalim && claimLength === 0 && (
        <EmptyClaimSubmitModal
          show={resubmitCalim}
          onClose={() => setResubmitClaims(false)}
          title={title}
          description={description}
        />
      )}
      {submitCalim && claimLength === 0 && (
        <EmptyClaimSubmitModal
          show={submitCalim}
          onClose={() => setSubmitClaims(false)}
          title={title}
          description={description}
        />
      )}

      {show && claimLength > 0 && (
        <SubmitClaimModal
          show={show}
          onClose={() => setShow(false)}
          claims={claims}
          status={status}
          description={description}
          setErrorDescription={setErrorDescription}
          setShowFailedModal={setShowFailedModal}
          setShowSuccessModal={setShowSuccessModal}
          body={body}
          setPage={setPage}
          setRowsPerPage={setRowsPerPage}
        />
      )}

      {claimLength > 0 && (
        <CancelMultipleClaimModal
          show={cancelCaims}
          onClose={() => setCancelClaims(false)}
          claims={claims}
          setCancelData={setCancelData}
          description={description}
          setShowCancelFailedModal={setShowCancelFailedModal}
          setShowSuccessModal={setShowSuccessModal}
          status="cancel"
          body={body}
          setPage={setPage}
          setRowsPerPage={setRowsPerPage}
        />
      )}
      {claimLength > 0 && (
        <ResubmitMultipleclaimModal
          show={resubmitCalim}
          onClose={() => setResubmitClaims(false)}
          claims={claims}
          description={description}
          setShowResubmitFailedModal={setShowResubmitFailedModal}
          setResubmitData={setResubmitData}
          setShowSuccessModal={setShowSuccessModal}
          status="resubmit"
          body={body}
          setPage={setPage}
          setRowsPerPage={setRowsPerPage}
        />
      )}

      {claimLength > 0 && (
        <SuccessSubmitModal
          modal={showSuccessModal}
          setModal={setShowSuccessModal}
          title={"Success"}
          description={
            status === "submit"
              ? "Claim(s) submission is in progress."
              : `Claim(s)  ${status} Successfully.`
          }
          setSelectedAction={setSelectedAction}
        />
      )}

      <ErrorMultiplecancelModal
        error={cancelData}
        onClose={() => setShowCancelFailedModal(false)}
        show={showCancelFailedModal}
        body={body}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
      />

      <ErrorMultipleResubmitModal
        error={resubmitData}
        onClose={() => setShowResubmitFailedModal(false)}
        show={showResubmitFailedModal}
        body={body}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
      />

      <EmptyClaimSubmitModal
        show={showFailedModal}
        onClose={() => setShowFailedModal(false)}
        title={"Failed"}
        description={errorDescription}
      />

      {submitCalim && claimLength > 0 && (
        <SubmitMultipleClaimModal
          show={submitCalim}
          claims={claims}
          claimLength={claimLength}
          setShowSuccessModal={setShowSuccessModal}
          description={description}
          onClose={() => setSubmitClaims(false)}
          body={body}
          setPage={setPage}
          setRowsPerPage={setRowsPerPage}
          setErrorDescription={setErrorDescription}
          setShowFailedModal={setShowFailedModal}
        />
      )}
    </>
  );
};

export default TableComponentHeader;
